import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query ViLabelProgress ($id: ID!) {
      ViLabelProgress (id: $id) {
        ...viLabelProgressDetail
      }
    }
    ${fragments.viLabelProgressDetail}
  `
